import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import { SocialIcon } from "react-social-icons"

type LinkGroupProps = {
  title: string
  links: { url: string; label: string }[]
}

const LinkGroup = ({ title, links }: LinkGroupProps) => {
  return (
    <div className="col-span-2 space-y-4">
      <div className="uppercase font-medium tracking-wide">{title}</div>
      <div className="flex space-y-3 flex-col">
        {links
          ? links.map(link =>
              /^http/.test(link.url) ? (
                <a href={link.url} key={link.url}>
                  {link.label}
                </a>
              ) : (
                <Link to={link.url} key={link.url}>
                  {link.label}
                </Link>
              )
            )
          : ""}
      </div>
    </div>
  )
}

const Footer = () => {
  const {
    footerMenu: {
      menuItems: { nodes: footerMenuItems },
    },
    subFooterMenu: {
      menuItems: { nodes: subFooterMenuItems },
    },
    socialMediaMenu: {
      menuItems: { nodes: socialMediaMenuItems },
    },
  } = useStaticQuery(graphql`
    query FooterMenuQuery {
      footerMenu: wpMenu(name: { eq: "Footer" }) {
        menuItems {
          nodes {
            id
            parentId
            label
            url
            path
            order
          }
        }
      }
      subFooterMenu: wpMenu(name: { eq: "sub_footer" }) {
        menuItems {
          nodes {
            id
            parentId
            label
            url
            path
            order
          }
        }
      }
      socialMediaMenu: wpMenu(name: { eq: "Sociala medier" }) {
        menuItems {
          nodes {
            id
            parentId
            label
            url
            path
            order
          }
        }
      }
    }
  `)

  const linkGroups = footerMenuItems
    .filter(item => !item.parentId)
    .map(topItem => {
      const links = footerMenuItems
        .filter(item => item.parentId == topItem.id)
        .sort((a, b) => (a.order < b.order ? -1 : 1))
        .map(item => ({
          label: item.label,
          url: item.path,
        }))
      return (
        <LinkGroup title={topItem.label} links={links} key={topItem.label} />
      )
    })

  return (
    <footer className="px-7 md:px-12 bg-gray-50">
      <div className=" max-w-screen-xl mx-auto">
        <div className="py-12 grid grid-cols-4 sm:grid-cols-10 gap-6 text-sm">
          {linkGroups}
        </div>
        <div className="flex space-x-4 justify-center sm:justify-start">
          {socialMediaMenuItems.map(socialMedia => (
            <SocialIcon
              url={socialMedia.url}
              className="w-full cursor-pointer"
              style={{ height: 30, width: 30 }}
              key={socialMedia.url}
            ></SocialIcon>
          ))}
        </div>
        <div className="py-6 flex flex-col-reverse space-y-2 space-y-reverse sm:space-y-0 sm:flex-row  items-center sm:justify-between text-xs">
          <div>© {new Date().getFullYear()}, Alternativ för Sverige.</div>
          <div className="space-x-6 ">
            {subFooterMenuItems.map(item => (
              <Link to={item.url} key={item.url}>
                {item.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
